module.exports = __webpack_public_path__ + "img/mediascience.6810158f.png";